import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';

export default function LoginInfoColumn() {
    return (
        <Box className="login-box-text">
            <Box className="login-info-text">
                <Trans i18nKey={`screens.login.sections.main.text`}></Trans>
            </Box>
        </Box>
    );
}